import React, { useState, useEffect, useCallback, useRef, useMemo } from "react";
import { Spinner, Col, Row, Container } from "react-bootstrap";
import { Button } from "../../stories/Buttons/Button";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import ListGroup from "react-bootstrap/ListGroup";
import {
  displayAccountFields,
  accountDetailsFields,
  heightWeightFields,
  lifestyleFullFields,
  medicalFullFields,
  DNAAsstSelectFields,
  changePasswordFields,
  medicalConditionFields,
  medicationFields,
  supplementFields,
  restestOrderKit,
  restestOrderKitModal,
} from "../../stories/Forms/fields";
import useApis from "../../services/useAPI";
import DisplayItems from "../TestDetails/DisplayItems";
import DynamicForm from "../../stories/Forms/DynamicForm";
import ModalForm from "../../stories/Modal/ModalForm";
import ToggleButtons from "../../stories/Buttons/ToggleButtons";
import {
  countriesUrl,
  editAccountDetailsUrl,
  accountSettings,
  orderRetestKit,
  getUserHealthInformtion,
  postCoderurl,
  logoutUrl, cookieExpirationTime
} from "../../utils/constants";
import { useAuth } from "../../components/AuthContext/AuthContext";
import { BoxArrowInRight, XSquare } from "react-bootstrap-icons";
import {
  editDetailsSchema,
  personalDetailsSchema,
  heightWeightSchema,
  lifestyleSchema,
  medicalSchema,
  exerciseSchema,
  medicalConditionsMedicationsSupplementsSchema,
  dnaAssessmentOnlySchema,
  changePasswordSchema,
  retestKitValidationSchema,
  retestKitValidationModalSchema
} from "../../stories/Forms/validationSchema";
import BodyMetrics from "../../components/BodyMetrics";
import UserProfile from "../../components/UserProfile";
import convert from "convert-units";
import editIcon from "../../assets/icons/edit-details.svg";
import saveChangesIcon from "../../assets/icons/correct-tick.svg";
import DynamicAccordion from "../../stories/Accordion/DynamicAccordion";
import FieldRenderer from "../../stories/Forms/FieldRenderer";
import { Formik, Form, Field, ErrorMessage } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import FormInput from "../../stories/Forms/FormInput";
import CheckboxGroupForm from "../../stories/Forms/CheckboxGroupForm";
import infoIcon from "../../assets/icons/new-info-icon.svg";
import DynamicModal from "../../stories/Modal/DynamicModal";
import { useMediaQuery } from "react-responsive";
import { fetchAddressOptions, removeCountryCode, parseAddress, toMatric, removeCountryCodeForUkNumber, getCountryFromPhone } from "../../utils/utils";

/**
 * Account component to display and edit user account details.
 * @returns {JSX.Element} A section for displaying account information with an option to edit.
 */

// Pure helper: derives consent label from status string (no side effects)
const getConsentLabel = (status) => {
  switch (status) {
    case "inactive":
      return (
        <>
          Not Registered –{" "}
          <a class="text-mhc-berry" href="/#nhs-card-id">
            Sign up
          </a>
        </>
      );
    case "consented":
      return "Registered";
    case "withdrawn-consent":
      return "Consent Withdrawn";
    case "consent-reactivated":
      return "Consent Reactivated";
    default:
      return "";
  }
};

const Account = () => {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();
  const [accountDetails, setAccountDetails] = useState({});
  const [isEmailMfa, setIsEmailMfa] = useState(false);
  const [initialValues, setInitialValues] = useState([]);
  const [retestOrderInitialValues, setRetestOrderInitialValues] = useState([]);
  const [updatedPersonalDetails, setUpdatedPersonalDetails] = useState([]);
  const [isEditMode, setIsEditMode] = useState(false);
  const [isEditHealthMode, setIsEditHealthMode] = useState(false);
  const [isSettingsEdit, setIsSettingsEdit] = useState(false);
  const [countries, setCountries] = useState([]);
  const [modalShow, setModalShow] = useState(false);
  const [passwordShowModal, setPasswordShowModal] = useState(false);
  const [isDNAUpdate, setIsDNAUpdate] = useState(false);
  const [isDNAUpdateOpen, setIsDNAUpdateOpen] = useState(false);
  const [height, setHeight] = useState(0);
  const [weight, setWeight] = useState(0);
  const [retestKitModal, setRetestKitModal] = useState(false);
  const userId = localStorage.getItem("user_id");
  const formikRef = useRef(null);
  const marketingConsentFormikRef = useRef(null);
  const heightWeightFormikRef = useRef(null);
  const lifestyleFormikRef = useRef(null);
  const medicalFormikRef = useRef(null);
  const dnaFormikRef = useRef(null);
  const changePasswordFormikRef = useRef(null);
  const retestOrderFormikRef = useRef(null);
  const emailMfa = sessionStorage.getItem("email_mfa") === "true";
  const retestOrderModalFormikRef = useRef(null);
  const [heightWeightInitialValues, setHeightWeightInitialValues] = useState(
    [],
  );
  const [
    changePasswordFieldsInitialValues,
    setChangePasswordFieldsInitialValues,
  ] = useState([]);
  const [lifeStyleInitialValues, setLifeStyleInitialValues] = useState([]);
  const [medicalInitialValues, setMedicalInitialValues] = useState([]);
  const [dnaInitialValues, setDNAInitialValues] = useState([]);
  const [addressOptions, setAddressOptions] = useState([]);
  const [marketingConsent, setMarketingConsent] = useState(
    accountDetails?.marketing_consent || false,
  );
  const [healthValidationError, setHealthValidationError] = useState("");
  const [isEditRetestMode, setIsEditRetestMode] = useState(false);
  const isMobile = useMediaQuery({ maxWidth: 576 });
  const [isRetest, setIsRetest] = useState(false);
  const [activeTab, setActiveTab] = useState("personal");
  const [testKitId, setTestKitId] = useState(null);
  // Use two separate API hook instances to avoid resultGet conflicts.
  // If your useApis hook doesn't support multiple instances, see note below.
    const {
    callApi: callAccountApi,
    resultGet: accountResult,
    isLoading: accountResultIsLoading,
    serverError: accountServerError,
  } = useApis();

    useEffect(() => {
      const params = new URLSearchParams(location.search);
      const retestParam = params.get("retest") === "true";
      const testKitId = params.get("testkitId");
      setIsRetest(retestParam);
      setTestKitId(testKitId)
    }, [location.search]);

    useEffect(() => {
      if ((isRetest && accountResult?.data?.is_retest_kit === true) || testKitId !==null) {
        setActiveTab("orderRetest");
      }
    }, [isRetest,accountResult]);

  const applyDisabledToFields = (fields, disabled) => {
    return fields
      .filter((field) => field?.type !== "submit")
      .map((field) => {
        // Handle children array (for groups, inline-groups, section-cards, etc.)
        if (field.children && Array.isArray(field.children)) {
          return {
            ...field,
            children: applyDisabledToFields(field.children, disabled),
          };
        }

        // Handle check_box_group array (for checkbox groups)
        if (field.check_box_group && Array.isArray(field.check_box_group)) {
          return {
            ...field,
            check_box_group: field.check_box_group.map((checkboxItem) => ({
              ...checkboxItem,
              disabled: disabled,
              readOnly: disabled,
            })),
            disabled: disabled,
            readOnly: disabled,
          };
        }

        if (field.controlId === "007") {
          return { ...field, disabled };
        }

        return {
          ...field,
          disabled,
          readOnly: disabled,
        };
      });
  };
  // Helper to apply disabled/readOnly to health fields
  const applyHealthDisabled = (fields, disabled) => {
    return fields
      .filter((field) => field?.type !== "submit")
      .map((field) => {
        if (field.children && Array.isArray(field.children)) {
          return {
            ...field,
            children: applyHealthDisabled(field.children, disabled),
          };
        }
        return {
          ...field,
          disabled,
          readOnly: disabled,
        };
      });
  };
  const retestOrderKitFields = applyDisabledToFields(
    restestOrderKit,
    !isEditRetestMode,
  );
  // let formFields = applyDisabledToFields(accountDetailsFields, !isEditMode);
  


  const heightWeightField = applyDisabledToFields(
    heightWeightFields,
    !isEditHealthMode,
  ).map(({ title, ...rest }) => rest);

  const lifestyleFullField = applyDisabledToFields(
    lifestyleFullFields,
    !isEditHealthMode,
  );
  const medicalFullField = applyDisabledToFields(
    medicalFullFields,
    !isEditHealthMode,
  );
  const DNAAsstSelectField = applyDisabledToFields(
    DNAAsstSelectFields,
    !isEditHealthMode,
  );

  const { callApi, resultGet, isLoading, serverError } = useApis();



  const {
    callApi: callAccountUpdateApi,
    resultPost: accountResultPost,
    serverError: accountUpdateServerError,
  } = useApis();

  const {
    callApi: callAddressUpdateApi,
    resultPost: addressUpdatePost,
    serverError: addressUpdateServerError,
  } = useApis();

  const { callApi: callLogoutApi } = useApis();

  const {
    callApi: callHealthApi,
    resultPost: healthResultPost,
    resultGet: healthResultGet,
    isLoading: healthIsLoading,
    serverError: healthServerError,
  } = useApis();

  const {
    callApi: callSettingsPostApi,
    resultPost: settingsResultPost,
    isLoading: settingsIsLoading,
    serverError: settingsServerError,
  } = useApis();

  const {
    callApi: callChangePasswordApi,
    resultPost: changePasswordResultPost,
    isLoading: changePasswordIsLoading,
    serverError: changePasswordServerError,
  } = useApis();

  const {
    callApi: callRetestOrderApi,
    resultPost: retestOrderResultPost,
    isLoading: retestOrderIsLoading,
    serverError: retestOrderServerError,
  } = useApis();

  const disabledFieldsRestestOrderKit = restestOrderKit.map((field) => {
    if (field.type === "group") {
      return {
        ...field,
        children: field.children.map((child) => ({
          ...child,
          disabled: true,
          readOnly: true,
        })),
      };
    }

    return {
      ...field,
      readOnly: true,
      disabled: true,
    };
  });
  const { callApi: callCountriesApi, resultGet: countriesResult } = useApis();

  // ─── Fetch account details on mount and when userId changes ───────────────
  const fetchAccountDetails = useCallback(() => {
    callAccountApi(null, editAccountDetailsUrl(userId), "GET");
    callHealthApi(null, getUserHealthInformtion(userId), "GET");
    callHealthApi(null, getUserHealthInformtion(userId), "GET");
  }, [userId]); // callAccountApi is stable from the hook

  const hasDnaTest = accountDetails?.has_dna_tests || false;

  const handleCodeBlur = async (code, setFieldValue) => {
    const trimmedCode = code.replace(/\s+/g, "");

    // Early return if empty
    if (!trimmedCode) {
      setFieldValue("home_street_address", "");
      setAddressOptions([]);
      return;
    }
    await fetchAddressOptions({
      trimmedCode,
      callApi,
      postCoderurl,
      setAddressOptions,
      setFieldValue,
    });
  };

  useEffect(() => {
    fetchAccountDetails();
  }, [fetchAccountDetails]);

  // ─── Fetch countries once on mount ────────────────────────────────────────
  useEffect(() => {
    callCountriesApi(null, countriesUrl, "GET");
  }, []); // intentionally runs once

  // ─── Populate countries list ──────────────────────────────────────────────
  useEffect(() => {
    if (countriesResult?.countries) {
      setCountries(countriesResult.data);
    }
  }, [countriesResult]);

  useEffect(() => {
    setMarketingConsent(accountDetails?.marketing_consent || false);
  }, [accountDetails]);

  const handleToggle = (e) => {
    const toggleValue = e.target.checked;

    setMarketingConsent(toggleValue);

    handleSettingsSubmit(toggleValue);
  };

  useEffect(() => {
    if (
      serverError === "Postcode lookup failed. Please try again later." ||
      serverError === "Invalid postcode format"
    ) {
      auth?.showToast("Error", serverError, "../assets/mhc.png", <XSquare />);
    }
  }, [serverError]);

let formFields = applyDisabledToFields(accountDetailsFields, !isEditMode).map((field) =>
  field.name === "phone_number_primary"
    ? { ...field, clearOnNonUkSwitch: true, savedNumberIsNonUk: isEmailMfa === true }
    : field
);
if (auth?.isNonUKNumber === true) {
  formFields = formFields.map((field) =>
    field.name === "phone_number_primary"
      ? {
          ...field,
          type: "advancePhoneNumber",
          controlId: "advancePhoneNumber",
          handleChange: (e, setFieldValue) =>
            setFieldValue(field.name, e.target.value),
        }
      : field
  );
}
  // ─── Populate account details (consent derived inline, no extra state) ────
  useEffect(() => {
    if (!accountResult?.success) return;
    let data = accountResult.data ?? {};
    
    if (accountResult.message === "User details retrived" && auth?.isPkbLive) {
      const consentLabel = getConsentLabel(data.user_pkb_status);
      setAccountDetails({
        ...data,
        nhs_results: consentLabel,
        nhs_number: data.user_nhs_number ?? null,
      });
    } else {
      setAccountDetails({ ...data });
    }
    setIsEmailMfa(data.email_mfa);
    auth.setPrimaryPhoneNumber(data?.phone_number_primary);
      auth.setIsNonUKNumber(data?.email_mfa);
      if (data?.email_mfa === true) {
        formFields = formFields.map((field) =>
          field.name === "phone_number_primary"
            ? {
                ...field,
                type: "advancePhoneNumber",
                controlId: "advancePhoneNumber",
                handleChange: (e, setFieldValue) =>
                  setFieldValue(field.name, e.target.value),
              }
            : field,
        );
      }
    let personalDetails = {
      first_name: data?.first_name || "",
      last_name: data?.last_name || "",
      dob: data?.dob || "",
      home_postal_code: data?.home_postal_code || "",
      home_street_address: data?.home_street_address || "",
      home_city: data?.home_city || "",
      home_country: "UK",
      ethnicity: data?.ethnicity || "",
      address_line_1: data?.address_line_1 || "",
      address_line_2: data?.address_line_2 || "",
      identify_with_gender: data?.identify_with_gender ?? "",
      sex: data?.sex || "",
      phone_number_primary: (data?.email_mfa ? data?.phone_number_primary : removeCountryCodeForUkNumber(data?.phone_number_primary)) || "",
    };

    let retestkitDetails = {
      first_name: data?.first_name || "",
      last_name: data?.last_name || "",
      home_postal_code: data?.home_postal_code || "",
      home_street_address: data?.home_street_address || "",
      home_city: data?.home_city || "",
      home_country: "UK",
      address_line_1: data?.address_line_1 || "",
      address_line_2: data?.address_line_2 || "",
    };

    setInitialValues(personalDetails);
    let retestkitDetailsAllFields = {
      ...retestkitDetails,
      retest_instructions: false,
      understand_refund_consent: false,
    };
    setRetestOrderInitialValues(retestkitDetailsAllFields);

    let height = data?.height;
    let weight = data?.weight;
    let heightunits = data?.height_units;
    let weightunits = data?.weight_units;

    if (heightunits === "metric") {
      const heightInMeter = parseFloat(
        convert(height).from("cm").to("m").toFixed(2),
      );
      setHeight(heightInMeter);
      setWeight(weight);
    } else if (heightunits === "imperial") {
      const imperialConverted = {
        height: Number(convert(height).from("in").to("m").toFixed(2)),
      };
      setHeight(imperialConverted?.height);
    }

    if (weightunits === "imperial") {
      const imperialConverted = {
        weight: Number(convert(weight).from("lb").to("kg").toFixed(2)),
      };
      setWeight(imperialConverted?.weight);
    }
  }, [accountResult, auth?.isPkbLive]);

  useEffect(() => {
    if (healthResultGet) {
      const body = healthResultGet?.height_and_weight?.body;
      let height = body?.height || "";
      let heightUnits = body?.heightUnits || "metric";
      if (heightUnits?.toLowerCase() === "imperial" && height !== "") {
        const convertedHeight = toMatric(height, heightUnits);

        height = convertedHeight.value;
        heightUnits = convertedHeight.unit;
      }
      let heightWeightInitialValues = {
        height,
        heightUnits,
        weight: body?.weight || "",
        weightUnits: body?.weightUnits || "metric",
        ispregnant: body?.ispregnant || "No",
        trimester: body?.trimester || "",
      };

      let lifestyleInitialValues = {
        smoking: healthResultGet?.lifestyle?.smoking?.smoking || "",
        cigarettes_per_day:
          healthResultGet?.lifestyle?.smoking?.cigarettes_per_day || null,
        how_many_year:
          healthResultGet?.lifestyle?.smoking?.how_many_year || null,
        how_many_day_average:
          healthResultGet?.lifestyle?.smoking?.how_many_day_average || null,
        alcohol: healthResultGet?.lifestyle?.alcohol?.alcohol || "",
        alcohol_units_per_week:
          healthResultGet?.lifestyle?.alcohol?.alcohol_units_per_week || null,
        physical_activity:
          healthResultGet?.lifestyle?.activity?.physical_activity || "",
        light_activity_hours_per_week:
          healthResultGet?.lifestyle?.activity?.light_activity_hours_per_week ||
          null,
        moderate_activity_hours_per_week:
          healthResultGet?.lifestyle?.activity
            ?.moderate_activity_hours_per_week || null,
        vigorous_activity_hours_per_week:
          healthResultGet?.lifestyle?.activity
            ?.vigorous_activity_hours_per_week || null,
      };
      let medicalInitialValues = {
        condition:
          healthResultGet?.medical_conditions?.medical_conditions?.condition ||
          [],
        was_diagnosed:
          healthResultGet?.medical_conditions?.medical_conditions
            ?.is_diagnosed || "No",
        cancer_type:
          healthResultGet?.medical_conditions?.medical_conditions
            ?.cancer_type || "",
        deficiency:
          healthResultGet?.medical_conditions?.medical_conditions?.deficiency ||
          "",
        other_description:
          healthResultGet?.medical_conditions?.medical_conditions
            ?.other_description || "",

        // medical_details: healthResultGet?.medical_conditions?.medical_conditions?.other_description || "",
        medication:
          healthResultGet?.medical_conditions?.medications?.medication || "No",
        medications:
          healthResultGet?.medical_conditions?.medications?.medications || [],
        specify_medication:
          healthResultGet?.medical_conditions?.medications
            ?.specify_medication || "",
        medical_other_description:
          healthResultGet?.medical_conditions?.medications?.other_description ||
          "",
        // details: healthResultGet?.medical_conditions?.medications?.other_description || "",

        taking_supplements:
          healthResultGet?.medical_conditions?.supplements
            ?.taking_supplements || "No",
        supplements:
          healthResultGet?.medical_conditions?.supplements?.supplements || [],
        supplement_details:
          healthResultGet?.medical_conditions?.supplements
            ?.supplement_details || "",
        supplement_other_description:
          healthResultGet?.medical_conditions?.supplements?.other_description ||
          "",
      };

      let dnaInitialValues = {
        dairy: healthResultGet?.dietary_preferences?.dairy || "",
        nuts: healthResultGet?.dietary_preferences?.nuts || "",
        gluten: healthResultGet?.dietary_preferences?.gluten || "",
        shellfish: healthResultGet?.dietary_preferences?.shellfish || "",
        oily_fish: healthResultGet?.dietary_preferences?.oily_fish || "",
        eggs: healthResultGet?.dietary_preferences?.eggs || "",
        poultry: healthResultGet?.dietary_preferences?.poultry || "",
        red_meat: healthResultGet?.dietary_preferences?.red_meat || "",
        pork: healthResultGet?.dietary_preferences?.pork || "",
        alcohol: healthResultGet?.dietary_preferences?.alcohol || "",
      };

      setHeightWeightInitialValues(heightWeightInitialValues);
      setLifeStyleInitialValues(lifestyleInitialValues);
      setMedicalInitialValues(medicalInitialValues);
      setDNAInitialValues(dnaInitialValues);

      let changePasswordFieldsInitialValues = {
        currentPassword: "",
        newPassword: "",
        confirmPassword: "",
      };
      setChangePasswordFieldsInitialValues(changePasswordFieldsInitialValues);
    }
  }, [healthResultGet]);

  useEffect(() => {
    if (changePasswordResultPost?.success) {
      auth?.showToast(
        "Success",
        changePasswordResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      handleModalClose();
      fetchAccountDetails();
    } else if (changePasswordServerError) {
      auth?.showToast(
        "Error",
        changePasswordServerError,
        "../assets/mhc.png",
        <XSquare />,
      );
    }
  }, [changePasswordResultPost, changePasswordServerError]);

  useEffect(() => {
    if (retestOrderResultPost?.success) {
      auth?.showToast(
        "Success",
        retestOrderResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      handleRetestKitModal();
      fetchAccountDetails();
      navigate("/account");
    } else if (retestOrderServerError) {
      auth?.showToast(
        "Error",
        retestOrderServerError,
        "../assets/mhc.png",
        <XSquare />,
      );
    }
  }, [retestOrderResultPost, retestOrderServerError]);

  // ─── Handle POST result (edit submission feedback) ────────────────────────
  useEffect(() => {
    if (accountResultPost?.data) {
      auth?.showToast(
        "Success",
        accountResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      setIsEditMode(false);
      setModalShow(false);
    } else if (accountServerError) {
      auth?.showToast(
        "Error",
        "error while submitting account details",
        "../assets/mhc.png",
        <XSquare />,
      );
    }
  }, [accountResultPost, accountServerError]); // fetchAccountDetails & auth are stable refs

  useEffect(() => {
    if (accountResultPost?.data) {
        let retestkitDetails = {
      first_name: accountResultPost?.data?.first_name || "",
      last_name: accountResultPost?.data?.last_name || "",
      home_postal_code: accountResultPost?.data?.home_postal_code || "",
      home_street_address: accountResultPost?.data?.home_street_address || "",
      home_city: accountResultPost?.data?.home_city || "",
      home_country: "UK",
      address_line_1: accountResultPost?.data?.address_line_1 || "",
      address_line_2: accountResultPost?.data?.address_line_2 || "",
      retest_instructions: false,
      understand_refund_consent: false,
    };
      auth.setIsNonUKNumber(accountResultPost?.data?.email_mfa);
      setIsEmailMfa(accountResultPost?.data?.email_mfa);
      setRetestOrderInitialValues(retestkitDetails)
      auth?.showToast(
        "Success",
        accountResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      setIsEditMode(false);
      setModalShow(false);
    } else if (accountUpdateServerError) {
      // ← updated
      auth?.showToast(
        "Error",
        "error while submitting account details",
        "../assets/mhc.png",
        <XSquare />,
      );
    }
  }, [accountResultPost, accountUpdateServerError]);

  useEffect(() => {
    if (settingsServerError) {
      auth.showToast(
        "Error",
        settingsServerError,
        "../assets/mhc.png",
        <XSquare />,
      );
      return;
    }

    if (settingsResultPost) {
      auth.showToast(
        "Success",
        settingsResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
    }
  }, [settingsResultPost, settingsServerError]);

  useEffect(() => {
    if (healthServerError) {
      auth.showToast(
        "Error",
        healthServerError,
        "../assets/mhc.png",
        <XSquare />,
      );
      return;
    }

    if (healthResultPost) {
      auth.showToast(
        "Success",
        healthResultPost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      if (isDNAUpdate === true && hasDnaTest) {
        setIsDNAUpdateOpen(true);
      }
      setIsDNAUpdate(false);
      callHealthApi(null, getUserHealthInformtion(userId), "GET");
    }
  }, [healthResultPost, healthServerError]);

  // ─── Filter display fields based on PKB Live flag ─────────────────────────
  const displayFields = displayAccountFields.filter((field) => {
    if (field.visibleInDisplay === false) return false;
    if (!auth?.isPkbLive) {
      return (
        !field.name.includes("nhs_results") &&
        !field.name.includes("nhs_number")
      );
    }
    return true;
  });

  const accordionSections = [
    {
      eventKey: "0",
      class: "height-weight",
      title: <span>Height and weight</span>,
      fields: heightWeightField,
      formikRef: heightWeightFormikRef,
      validationSchema: heightWeightSchema,
      initialValues: heightWeightInitialValues,
    },
    {
      eventKey: "1",
      class: "lifeStyle",
      title: <span>Lifestyle</span>,
      fields: lifestyleFullField,
      formikRef: lifestyleFormikRef,
      validationSchema: lifestyleSchema,
      initialValues: lifeStyleInitialValues,
    },
    {
      eventKey: "2",
      class: "medical-conditions",
      title: <span>Medical conditions</span>,
      fields: medicalFullField,
      formikRef: medicalFormikRef,
      validationSchema: medicalSchema,
      initialValues: medicalInitialValues,
    },
    {
      eventKey: "3",
      class: "dietary-preferences",
      title: (
        <span>
          Dietary Preferences <small>(required for DNA tests)</small>
        </span>
      ),
      fields: DNAAsstSelectField,
      formikRef: dnaFormikRef,
      validationSchema: null,
      initialValues: dnaInitialValues,
    },
  ];

  const handlePersonalDetailsSubmit = async (formData) => {
    auth.setCountrySelected(formData?.phone_number_primary_country || "");
    if (formData.home_street_address !== "No results") {
      formData.address_line_1 = "";
      formData.address_line_2 = "";
      formData.home_city = null;
      formData.home_country = null;
    }
    setUpdatedPersonalDetails(formData);
    setInitialValues({
  ...formData,
  phone_number_primary: auth.isNonUKNumber
    ? formData?.phone_number_primary
    : removeCountryCodeForUkNumber(formData?.phone_number_primary),
});
    formikRef.current?.resetForm({ values: formData });
     const rawNumber = formData.phone_number_primary.trim().replace(/\s+/g, "");
       const bareNumber = removeCountryCodeForUkNumber(rawNumber).replace(
         /\s+/g,
         "",
       );
       const countryCode =
         formData.phone_number_primary_country ||
         `${getCountryFromPhone(rawNumber)?.code  !== undefined ? '+' :'+44'}${getCountryFromPhone(rawNumber)?.code || ""}`;

       formData.phone_number_primary = countryCode
         ? `${countryCode}${bareNumber}`
         : bareNumber;

        auth.setPrimaryPhoneNumber(formData.phone_number_primary);
    setIsEditMode(false);
       const payload = {
      ...formData,
      phone_number_primary: `${formData.phone_number_primary.trim().replace(/\s+/g, "")}`,
      email_mfa: auth.isNonUKNumber
    };
    try {
      callAccountUpdateApi(payload, editAccountDetailsUrl(userId), "PUT");
    } catch (error) {
       auth?.showToast(
       "Error",
       "error while submitting account details",
       "../assets/mhc.png",
       <XSquare />,
     );
}
  };

  const handleHealthInformationSumit = async (formData) => {
    try {
      callHealthApi(formData, getUserHealthInformtion(userId), "POST");
    } catch (error) {
      console.log(error);
    }
    setIsEditHealthMode(!isEditHealthMode);
  };

  const encodeToBase64 = (text) => {
    // Convert the string to a UTF-8 encoded byte array
    const encoder = new TextEncoder();
    const utf8Bytes = encoder.encode(text);

    // Convert the byte array to a Base64 string
    const base64String = btoa(String.fromCodePoint(...utf8Bytes));

    return base64String;
  };
  const handleChangePassword = async (formData) => {
    setChangePasswordFieldsInitialValues(formData);
    const current_password = encodeToBase64(formData?.currentPassword.trim());
    const new_password = encodeToBase64(formData?.newPassword.trim());

    await callChangePasswordApi(
      { password: new_password, current_password: current_password },
      accountSettings,
      "POST",
    );
  };

  const handleRetestKitOrder = async (formData) => {
    if(formData && formData.home_street_address !== "No results"){
      let address = parseAddress(formData?.home_street_address);
      formData.address_line_1 = address?.address_line_1;
      formData.address_line_2 = address?.address_line_2;
      formData.home_city = address?.home_city;
    }
    let payload = {...formData, userId:localStorage.getItem("user_id"), retest_kit_id: testKitId || accountResult?.data?.retest_kit_id};
    setChangePasswordFieldsInitialValues(formData);
    await callRetestOrderApi(
      { ...payload },
      orderRetestKit,
      "POST",
    );
  };

  useEffect(() => {
    if (changePasswordResultPost?.success === true) {
      callLogoutApi(logoutUrl, "POST");
      auth.setIsAuthenticated(false);
      auth.setNextURl("");
      localStorage.clear();
      const cookies = document.cookie.split(";");
      cookies.forEach((cookie) => {
        const cookieName = cookie.split("=")[0].trim();
        document.cookie = `${cookieName + cookieExpirationTime}`;
      });
      navigate("/login");
      auth?.showToast(
        "Logged out",
        "Your password has been changed successfully. Please log in again using your new password.",
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
    }
  }, [changePasswordResultPost]);

  useEffect(() => {
    if (addressUpdatePost?.success) {
      auth?.showToast(
        "Success",
        addressUpdatePost.message,
        "../assets/mhc.png",
        <BoxArrowInRight />,
      );
      setIsEditRetestMode(false);
      fetchAccountDetails();
    } else if (addressUpdateServerError) {
      auth?.showToast(
        "Error",
        addressUpdateServerError,
        "../assets/mhc.png",
        <XSquare />,
      );
    }
  }, [addressUpdatePost, addressUpdateServerError]);

  // ─── Render ───────────────────────────────────────────────────────────────
  if (accountResultIsLoading) {
    return (
      <div className="text-center">
        <Spinner
          animation="border"
          role="output"
          className="my-custom-spinner"
        />
      </div>
    );
  }

  const triggerSubmit = async () => {
    // Validate all forms
    setHealthValidationError("");
    const isDnaChanged =
      JSON.stringify(dnaFormikRef.current?.values) !==
      JSON.stringify(dnaFormikRef.current?.initialValues);
    setIsDNAUpdate(isDnaChanged);
    const healthErrors =
      (await heightWeightFormikRef.current?.validateForm()) || {};

    const lifestyleErrors =
      (await lifestyleFormikRef.current?.validateForm()) || {};

    const medicalErrors =
      (await medicalFormikRef.current?.validateForm()) || {};

    const dnaErrors = (await dnaFormikRef.current?.validateForm()) || {};

    // Check if all forms are valid
    const isValid =
      Object.keys(healthErrors).length === 0 &&
      Object.keys(lifestyleErrors).length === 0 &&
      Object.keys(medicalErrors).length === 0 &&
      Object.keys(dnaErrors).length === 0;

    if (isValid) {
      setHealthValidationError("");
      const values = medicalFormikRef.current?.values;
      const formData = {
        heightWeightData: {
          body: {
            ...heightWeightFormikRef.current?.values,
          },
        },
        lifestyleData: {
          alcohol: {
            alcohol: lifestyleFormikRef.current?.values?.alcohol,
            alcohol_units_per_week:
              lifestyleFormikRef.current?.values?.alcohol === "Yes"
                ? lifestyleFormikRef.current?.values?.alcohol_units_per_week
                : null,
          },
          smoking: {
            smoking: lifestyleFormikRef.current?.values?.smoking,
            cigarettes_per_day:
              lifestyleFormikRef.current?.values?.smoking === "Yes"
                ? lifestyleFormikRef.current?.values?.cigarettes_per_day
                : null,
            how_many_year:
              lifestyleFormikRef.current?.values?.smoking === "Ex-smoker"
                ? lifestyleFormikRef.current?.values?.how_many_year
                : null,
            how_many_day_average:
              lifestyleFormikRef.current?.values?.smoking === "Ex-smoker"
                ? lifestyleFormikRef.current?.values?.how_many_day_average
                : null,
          },
          activity: {
            physical_activity:
              lifestyleFormikRef.current?.values?.physical_activity,
            vigorous_activity_hours_per_week:
              lifestyleFormikRef.current?.values?.physical_activity === "Yes"
                ? lifestyleFormikRef.current?.values
                    ?.vigorous_activity_hours_per_week
                : null,
            moderate_activity_hours_per_week:
              lifestyleFormikRef.current?.values?.physical_activity === "Yes"
                ? lifestyleFormikRef.current?.values
                    ?.moderate_activity_hours_per_week
                : null,
            light_activity_hours_per_week:
              lifestyleFormikRef.current?.values?.physical_activity === "Yes"
                ? lifestyleFormikRef.current?.values
                    ?.light_activity_hours_per_week
                : null,
          },
        },
        medicalData: {
          medications: {
            medication: values?.medication,
            medications: values?.medication === "No" ? [] : values?.medications,
            specify_medication:
              values?.medication === "Yes" &&
              values?.medications?.includes("Cholesterol-lowering")
                ? values?.specify_medication
                : "",
            other_description:
              values?.medication === "Yes" &&
              values?.medications?.includes("Other")
                ? values?.medical_other_description
                : "",
          },

          medical_conditions: {
            is_diagnosed: values?.was_diagnosed,
            condition: values?.was_diagnosed === "No" ? [] : values?.condition,
            deficiency:
              values?.was_diagnosed === "Yes" &&
              values?.condition?.includes("Vitamin/mineral deficiency")
                ? values?.deficiency
                : "",
            other_description:
              values?.was_diagnosed === "Yes" &&
              values?.condition?.includes("Other")
                ? values?.other_description
                : "",
            cancer_type:
              values?.was_diagnosed === "Yes" &&
              values?.condition?.includes("Cancer")
                ? values?.cancer_type
                : "",
          },

          supplements: {
            taking_supplements: values?.taking_supplements,
            supplements:
              values?.taking_supplements === "No" ? [] : values?.supplements,
            other_description:
              values?.taking_supplements === "No"
                ? ""
                : values?.supplement_other_description,
            supplement_details:
              values?.taking_supplements === "Yes" &&
              values?.supplements?.includes("Iron, Folate")
                ? values?.supplement_details
                : "",
            supplement_other_description:
              values?.taking_supplements === "Yes" &&
              values?.supplements?.includes("Other")
                ? values?.supplement_other_description
                : "",
          },
        },
        dnaData: {
          ...dnaFormikRef.current?.values,
        },
      };

      handleHealthInformationSumit(formData);
    } else {
      // Show validation messages
      setHealthValidationError(
        "Please complete all required fields before saving.",
      );
      heightWeightFormikRef.current?.setTouched(
        Object.keys(healthErrors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
      );

      lifestyleFormikRef.current?.setTouched(
        Object.keys(lifestyleErrors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
      );

      medicalFormikRef.current?.setTouched(
        Object.keys(medicalErrors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
      );

      dnaFormikRef.current?.setTouched(
        Object.keys(dnaErrors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
      );
    }
  };
  if (accountServerError) return <div>Error: {accountServerError}</div>;
  const handleModalClose = () => {
    setPasswordShowModal(false);
  };
  const handleDNAInfoModalClose = () => {
    setIsDNAUpdateOpen(false);
  };
  const handleModalOpen = () => {
    setPasswordShowModal(true);
  };

  const handleRetestKitModal = () => {
    setRetestKitModal(!retestKitModal);
  };

  const handleSettingsSubmit = (toggleValue) => {
    callSettingsPostApi(
      { marketing_consent: toggleValue, UserId: userId },
      accountSettings,
      "POST",
    );
  };

  const updateUserAddress = async () => {
    const formik = retestOrderFormikRef.current;
    if (!formik) return;
    const errors = (await formik.validateForm()) || {};
    const isValid = Object.keys(errors).length === 0;
    if (!isValid) return;
    let payload;
    if (formik.values.home_street_address !== "No results") {
      const { first_name, last_name, home_postal_code, home_street_address } =
        formik.values;

      payload = {
        first_name,
        last_name,
        home_postal_code,
        home_street_address,
      };
    } else {
      const {
        first_name,
        last_name,
        address_line_1,
        address_line_2,
        home_city,
        home_country,
        home_postal_code,
        home_street_address,
      } = formik.values;

      payload = {
        first_name,
        last_name,
        address_line_1,
        address_line_2,
        home_city,
        home_country,
        home_postal_code,
        home_street_address,
      };
    }
    callAddressUpdateApi(payload, editAccountDetailsUrl(userId), "PUT");
  };

  return (
    <>
      <UserProfile
        height={healthResultGet?.height_and_weight?.body?.height}
        heightUnits={healthResultGet?.height_and_weight?.body?.heightUnits}
        weightUnits={healthResultGet?.height_and_weight?.body?.weightUnits}
        weight={healthResultGet?.height_and_weight?.body?.weight}
        firstName={accountDetails?.first_name}
        gender={accountDetails?.sex}
        age={accountDetails?.age}
      />
      <div className={`account-section-buttons`}>
        <button
          type="button"
          onClick={() => setActiveTab("personal")}
          className={`btn ${
            activeTab === "personal" ? "btn-green" : "btn-outlined-new"
          }`}
        >
          Personal details
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("health")}
          className={`btn ${
            activeTab === "health" ? "btn-green" : "btn-outlined-new"
          }`}
        >
          Health information
        </button>

        <button
          type="button"
          onClick={() => setActiveTab("settings")}
          className={`btn ${
            activeTab === "settings" ? "btn-green" : "btn-outlined-new"
          }`}
        >
          Settings
        </button>
        {accountResult?.data?.is_retest_kit === true && (
            <button
              type="button"
              onClick={() => setActiveTab("orderRetest")}
              className={`btn ${
                activeTab === "orderRetest" ? "btn-green" : "btn-outlined-new"
              }`}
            >
              Order a retest
            </button>
          )}
      </div>
      <div
        className="personal-details-section"
        style={{ display: activeTab === "personal" ? "block" : "none" }}
      >
        <div
          className={`d-flex align-items-center ${
            isMobile ? "justify-content-between" : "flex-column"
          }`}
          style={{ marginBottom: `${isMobile ? "15px" : "9px"}` }}
        >
          {isMobile && (
            <p className="personal-info-title">Personal information</p>
          )}
          {!isEditMode && (
            <button
              type="button"
              className="btn btn-outlined-new edit-btn-common-cls align-self-end"
              onClick={() => setIsEditMode(!isEditMode)}
            >
              <img src={editIcon} alt="edit-icon" />{" "}
              <span className="btn-text">Edit details</span>
            </button>
          )}
          {isEditMode && (
            <button
              type="button"
              className="btn btn-green edit-btn-common-cls save-changes-btn align-self-end"
              onClick={() => formikRef.current?.submitForm()}
            >
              <img src={saveChangesIcon} alt="edit-icon" />{" "}
              <span className="btn-text">Save changes</span>
            </button>
          )}
        </div>
        {!isMobile && <p>Personal information</p>}
        <DynamicForm
          fields={formFields}
          formikRef={formikRef}
          onSubmit={(formData) => handlePersonalDetailsSubmit(formData)}
          validationSchema={personalDetailsSchema}
          initialValues={initialValues}
          handleCodeBlur={handleCodeBlur}
          addressOptions={addressOptions}
        />
      </div>
      <div
        className="health-information-section"
        style={{ display: activeTab === "health" ? "block" : "none" }}
      >
        <DynamicModal
          title="Your dietary preferences have been updated"
          modalClass="dna-info-modal"
          handleClose={handleDNAInfoModalClose}
          show={isDNAUpdateOpen}
          children={
            "We’re now refreshing your DNA test related recommendations to better match your latest preferences"
          }
          isFooter={false}
        />
        <div className="d-flex flex-column" style={{ marginBottom: "24px" }}>
          {!isEditHealthMode && (
            <button
              type="button"
              className="btn btn-outlined-new edit-btn-common-cls align-self-end"
              onClick={() => setIsEditHealthMode(true)}
            >
              <img src={editIcon} alt="edit-icon" />{" "}
              <span className="btn-text">Edit details</span>
            </button>
          )}
          {isEditHealthMode && (
            <button
              type="button"
              className="btn btn-green edit-btn-common-cls save-changes-btn align-self-end"
              onClick={triggerSubmit}
            >
              <img src={saveChangesIcon} alt="edit-icon" />{" "}
              <span className="btn-text">Save changes</span>
            </button>
          )}
          {healthValidationError && (
            <div className="invalid-feedback d-block my-2 fs-15">
              {healthValidationError}
            </div>
          )}
        </div>
        {accordionSections.map((section) => (
          <Accordion key={section.eventKey} className="mb-3">
            <Accordion.Item eventKey={section.eventKey}>
              <Accordion.Header className="accordian-title common-title-cls">
                {section.title}
              </Accordion.Header>
              <Accordion.Body
                className={`${section.class} common-accordian-body`}
              >
                <div className="account-details">
                  {section.eventKey === "3" && (
                    <div className="dna-info">
                      Please tell us which items you can't eat (allergy or
                      religious restriction), don't eat, or those you eat. This
                      helps customise your reports.
                    </div>
                  )}
                  {section.eventKey === "2" ? (
                    
                      <CheckboxGroupForm
                        className="assessment-form"
                        initialValues={medicalInitialValues}
                        formikRef={medicalFormikRef}
                        blockRefresh={false}
                        fields={[...medicalFullField]}
                        validationSchema={
                          medicalConditionsMedicationsSupplementsSchema
                        }
                        is_assessment_completed={true}
                        type={"medical_conditions_medications_supplements"}
                      />
                    
                  ) : (
                    <DynamicForm
                      fields={section.fields}
                      formikRef={section.formikRef}
                      validationSchema={section.validationSchema}
                      initialValues={section.initialValues}
                      sex={accountDetails?.sex}
                    />
                  )}
                </div>
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        ))}
      </div>
      <div
        className="settings-section"
        style={{ display: activeTab === "settings" ? "block" : "none" }}
      >
        <span className="settings-title">Account Information</span>
        <Card body className="settings-card">
          <ListGroup variant="flush">
            <ListGroup.Item>
              <div className="settings-email d-flex flex-column">
                <span className="text-muted settings-label">Email</span>
                <span className="settings-value">{accountDetails?.email}</span>
              </div>
            </ListGroup.Item>
            <ListGroup.Item>
              <div className="settings-password d-flex justify-content-between">
                <div className="password-wrapper d-flex flex-column">
                  <span className="text-muted settings-label">Password</span>
                  <span className="settings-value">*******</span>
                </div>
                <div className="edit-btn-section">
                  <button
                    className="email-password-edit-btn"
                    onClick={handleModalOpen}
                  >
                    Change Password
                  </button>
                </div>
              </div>
            </ListGroup.Item>
          </ListGroup>
        </Card>
        <div className="marketing-preferences">
          <span className="marketing-preferences-title">
            Marketing preferences:{" "}
            <small
              className={marketingConsent ? "color-pink" : "color-grey-border"}
            >
              {marketingConsent ? "Subscribed" : "Unsubscribed"}
            </small>
          </span>
          <br />
          <p className="description">
            Stay up to date with health insights, product updates, and exclusive
            offers from MyHealthChecked. Our team of doctors and nutritionists
            is here to support your health journey with expert-led articles,
            practical health advice, product news, and wellbeing tips delivered
            straight to your inbox.
          </p>
          <div className="form-check form-switch">
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                role="switch"
                id="flexSwitchCheckDefault"
                checked={marketingConsent}
                onChange={handleToggle}
              />

              <label
                className="form-check-label status-label"
                htmlFor="flexSwitchCheckDefault"
              >
                Receive health updates and offers
              </label>
            </div>
          </div>
          <div className="nhs-card-section d-flex flex-column">
            <span>
              See your results in the NHS App{" "}
              <img alt="info-icon" src={infoIcon} />
            </span>
            <span className="registered-cls">
              {getConsentLabel(accountDetails?.user_pkb_status)}
            </span>
            <small>
              We've partnered with Patients Know Best to securely share your
              test results with the NHS App for activated regions.{" "}
              <a 
                className="learn-more"           
                href="http://myhealthchecked.com/patients-know-best"
                target="_blank"
                rel="noreferrer">
                  Learn more.
                </a>
            </small>
          </div>
          {accountDetails?.user_nhs_number !== null && (
            <div className="nhs-card-number-section d-flex flex-column">
              <span>
                Verified NHS Number <img alt="info-icon" src={infoIcon} />
              </span>
              <span className="nhs-number-cls">
                {accountDetails?.user_nhs_number}
              </span>
              <small>
                If you believe your verified NHS number is incorrect, please
                report this to{" "}
                <a className="learn-more" href="mailto:care@myhealthchecked.com">care@myhealthchecked.com.</a>
              </small>
            </div>
          )}
        </div>
        <DynamicModal
          title="Password"
          modalClass="change-passward-modal"
          handleClose={handleModalClose}
          show={passwordShowModal}
          submitBtnText="Save Changes"
          formikRef={changePasswordFormikRef}
          children={
            <DynamicForm
              fields={changePasswordFields}
              formikRef={changePasswordFormikRef}
              onSubmit={(formData) => handleChangePassword(formData)}
              validationSchema={changePasswordSchema}
              initialValues={changePasswordFieldsInitialValues}
              enableReinitializeValue={true}
            />
          }
        />
      </div>
      <div
        className="orderRetest-section"
        style={{ display: activeTab === "orderRetest" ? "block" : "none" }}
      >
        <div className="retest-kit-details d-flex flex-column">
          <span className="description">
            Following your recent results email, you’re eligible to order a free
            retest kit. This option is available for up to 30 days. If you would
            like to proceed with a retest, please confirm your delivery address
            to place your order.
          </span>
          <span className="important-to-know">
            <small className="title">Important to know:</small>
            <ul>
              <li>Sample collection instructions must be carefully followed</li>
              <li>
                We will report any additional results we can obtain from your
                retest sample
              </li>
              <li>Only one free retest is permitted</li>
            </ul>
          </span>
          <small className="title mb-3">Delivery name and address</small>
          <DynamicForm
            fields={retestOrderKitFields}
            initialValues={initialValues}
            formikRef={retestOrderFormikRef}
            validationSchema={retestKitValidationSchema}
            handleCodeBlur={handleCodeBlur}
            addressOptions={addressOptions}
          />
          <div className="order-restest-buttons d-flex justify-content-between">
            {!isEditRetestMode && (
              <button
                type="button"
                className="btn btn-outlined-new edit-btn-common-cls align-self-end"
                onClick={() => setIsEditRetestMode(true)}
                disabled={
                  initialValues?.home_street_address?.trim() ||
                  initialValues?.address_line_1?.trim() ||
                  initialValues?.home_postal_code?.trim()
                }
              >
                <img src={editIcon} alt="edit-icon" />{" "}
                <span className="btn-text">Edit details</span>
              </button>
            )}
            {isEditRetestMode && (
              <button
                type="button"
                className="btn btn-green edit-btn-common-cls save-changes-btn align-self-end"
                onClick={() => updateUserAddress()}
              >
                <img src={saveChangesIcon} alt="edit-icon" />{" "}
                <span className="btn-text">Save changes</span>
              </button>
            )}
            <button
              type="button"
              className="btn btn-green"
              onClick={handleRetestKitModal}
            >
              Continue
            </button>
            <DynamicModal
              title="Submit my retest kit order"
              modalClass="retest-kit-modal-popup"
              handleClose={handleRetestKitModal}
              show={retestKitModal}
              formikRef={retestOrderModalFormikRef}
              submitBtnText="Submit order"
              retestOrderIsLoading={retestOrderIsLoading}
              children={
                <>
                  <DynamicForm
                    fields={restestOrderKitModal}
                    formikRef={retestOrderModalFormikRef}
                    onSubmit={(formData) => handleRetestKitOrder(formData)}
                    validationSchema={retestKitValidationModalSchema}
                    initialValues={retestOrderInitialValues}
                  />
                   <div>
                  <strong>Important to know</strong>
                  <p>
                      If you do not wish to proceed with a retest kit, please
                      contact{' '}
                      <a href="mailto:care@myhealthchecked.com">
                        care@myhealthchecked.com
                      </a>{' '}
                      with your proof of purchase and account details to
                      arrange a refund.
                    </p>
                </div>
                </>
              }
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default Account;
